(() => {
  const root = document.querySelector('[data-accessory-catalogue]');
  if (root) {
    const form = root.querySelector('[data-accessory-form]');
    const grid = root.querySelector('[data-accessory-grid]');
    const fields = [...form.querySelectorAll('[data-accessory-filter]')];
    const sort = form.querySelector('[data-accessory-sort]');
    const counter = root.querySelector('[data-accessory-count]');
    const empty = root.querySelector('[data-accessory-empty]');
    const products = [...root.querySelectorAll('script[data-shop-product]')].flatMap(node => {
      try { return [JSON.parse(node.textContent)]; } catch { return []; }
    });
    const config = window.CimbaliShopConfig || {};
    const multiplier = 1 + (config.vatRate ?? 23) / 100;
    const normalized = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
    const cards = products.map((product, index) => ({
      product,
      index,
      card: [...grid.querySelectorAll('[data-shop-card]')].find(card => card.dataset.shopCard === product.handle),
      net: Math.min(...product.variants.map(variant => config.taxesIncluded ? Number(variant.price) / multiplier / 100 : Number(variant.price) / 100)),
    })).filter(item => item.card);
    const keys = fields.map(field => field.dataset.accessoryFilter);
    function restore() {
      const params = new URL(location.href).searchParams;
      fields.forEach(field => { field.value = params.get('acc_' + field.dataset.accessoryFilter) || ''; });
      sort.value = params.get('acc_sort') || 'default';
    }
    function update(persist = true) {
      const values = Object.fromEntries(fields.map(field => [field.dataset.accessoryFilter, field.value]));
      const visible = cards.filter(item => {
        const accessory = item.product.enhance?.accessory || {};
        const group = accessory.group || (item.product.tags?.includes('lacimbali') ? 'equipment' : '');
        return (!values.group || group === values.group)
          && (!values.material || accessory.materials?.includes(values.material))
          && (!values.volume || Number(accessory.volume_ml) === Number(values.volume))
          && (!values.q || normalized(item.product.title + ' ' + item.product.enhance?.short + ' ' + item.product.variants.map(variant => variant.sku || '').join(' ')).includes(normalized(values.q)))
          && (!values.min || Math.round(item.net * 100) >= Math.round(Number(values.min) * 100))
          && (!values.max || Math.round(item.net * 100) <= Math.round(Number(values.max) * 100));
      });
      const ids = new Set(visible.map(item => item.product.handle));
      cards.forEach(item => { item.card.hidden = !ids.has(item.product.handle); });
      visible.sort((a, b) => sort.value === 'price_asc' ? a.net - b.net : sort.value === 'price_desc' ? b.net - a.net : sort.value === 'name_asc' ? a.product.title.localeCompare(b.product.title, document.documentElement.lang) : a.index - b.index);
      visible.forEach(item => grid.append(item.card));
      counter.textContent = counter.dataset.label + ': ' + visible.length + ' / ' + cards.length;
      empty.hidden = visible.length !== 0;
      if (persist) {
        const url = new URL(location.href);
        keys.forEach(key => { if (values[key]) url.searchParams.set('acc_' + key, values[key]); else url.searchParams.delete('acc_' + key); });
        if (sort.value !== 'default') url.searchParams.set('acc_sort', sort.value); else url.searchParams.delete('acc_sort');
        history.replaceState(null, '', url);
      }
    }
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('input', () => update());
    form.addEventListener('change', () => update());
    form.addEventListener('reset', () => requestAnimationFrame(() => update()));
    window.addEventListener('popstate', () => { restore(); update(false); });
    restore();
    update(false);
  }
  document.querySelectorAll('[data-barista-detail]').forEach(detail => {
    detail.querySelectorAll('[data-barista-image]').forEach(button => button.addEventListener('click', () => {
      const main = detail.querySelector('[data-barista-main-image]');
      if (!main) return;
      const next = button.querySelector('[data-gallery-template]')?.content.firstElementChild?.cloneNode(true);
      if (next?.tagName === 'IMG') { main.replaceWith(next); return; }
      main.removeAttribute('srcset');
      main.src = button.dataset.baristaImage;
      main.alt = button.dataset.baristaAlt;
    }));
  });
})();
